/* eslint-disable camelcase */
import isEmail from 'validator/lib/isEmail';
import { navigate } from 'gatsby';
import { captureException } from '@sentry/gatsby';

import PardotFormApi from '../../Utilities/pardotFormApi';
import hotjarIdentifyAPI from '../../../../utils/hotjarIdentify';
import { submitChiliPiper } from '../../Utilities/chiliPiper';

const errorMessages = {
  firstname: 'Please complete required field',
  lastname: 'Please complete required field',
  companyname: 'Please complete required field',
};

export const validateEmail = (e, validation, setValidation) => {
  const email = e.target.value;
  if (email === '') {
    setValidation({ ...validation, email: 'Please complete required field' });
    return false;
  }

  if (!isEmail(email)) {
    setValidation({
      ...validation,
      email: `Please provide a valid email address`,
    });
    return false;
  }

  setValidation({ ...validation, email: '' });
  return true;
};

export const validateOnChange = (e, type, validation, setValidation) => {
  const { value } = e.target;

  const isEmpty = Array.isArray(value) ? value.length === 0 : value === '';

  if (type === 'email') {
    validateEmail(e, validation, setValidation);
    return false;
  }
  if (isEmpty) {
    setValidation({ ...validation, [type]: errorMessages[type] });
    return false;
  }
  setValidation({ ...validation, [type]: '' });
};

export const validateOnSubmit = (data, validation, setValidation) => {
  const { firstname, lastname, companyname, email } = data;
  if (firstname === '') {
    setValidation({ ...validation, firstname: errorMessages.firstname });
    return {
      valid: false,
      error: 'firstname',
    };
  }
  if (lastname === '') {
    setValidation({ ...validation, lastname: errorMessages.lastname });
    return {
      valid: false,
      error: 'lastname',
    };
  }
  if (companyname === '') {
    setValidation({ ...validation, companyname: errorMessages.companyname });
    return {
      valid: false,
      error: 'companyname',
    };
  }
  const validEmail = validateEmail(
    { target: { value: email } },
    validation,
    setValidation
  );
  if (!validEmail) {
    return {
      valid: false,
      error: 'email',
    };
  }
  return {
    valid: true,
    error: '',
  };
};

const createPardotDemoPayload = data => ({
  firstname: data?.firstname,
  lastname: data?.lastname,
  email: data?.email,
  companyname: data?.companyname,
  jobtitle: data?.jobtitle,
  industry: data?.industry,
  industrydetail: data?.industrydetail,
  url: data?.url,
  DoNotRoute: data?.DoNotRoute,
  leadStatus: data?.LeadStatus,
  gclid: data?.gclid,
});

export const handleSubmit = ({
  e,
  data,
  setData,
  validation,
  setValidation,
  customFormHandler,
  setIsSubmitted,
  chiliPiperRouterId,
}) => {
  e.preventDefault();

  try {
    const { valid, error } = validateOnSubmit(data, validation, setValidation);

    if (!valid) {
      throw new Error(`Invalid form data for field: ${error}`);
    }

    PardotFormApi.ehsForm(
      createPardotDemoPayload(data),
      customFormHandler
    ).then(() => {
      submitChiliPiper(data, chiliPiperRouterId);

      setData({
        firstname: '',
        lastname: '',
        companyname: '',
        email: '',
        jobtitle: '',
        industry: '',
        industrydetail: '',
        url: '',
        gclid: '',
      });
      hotjarIdentifyAPI(data);
      setIsSubmitted(true);
    });
  } catch (error) {
    captureException(`EHS Form Error - ${error}`);
    console.error(error);
  }
};
